import React, { useEffect, useState } from 'react';
import classes from "./WinningHistory.module.css";
import { winningHistoryApi } from '../http/http';
import { toast } from 'react-toastify';
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import { FaArrowLeft } from 'react-icons/fa6';
import Container from '../component/Container';
import SmallLoader from '../component/SmallLoader';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const WinningHistory = () => {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await winningHistoryApi(userDetails?.token);
                setData(response?.data);

                // setData([
                //     {
                //         msisdn: "1234", rank: 1, total_points: 2000, month: "2026-04"
                //     },
                //      {
                //         msisdn: "1234", rank: 1, total_points: 2000, month: "2026-04"
                //     }
                // ])
            } catch (error) {
                toast.error(
                    error?.response?.data?.error?.error ||
                    error?.response?.error?.error ||
                    error?.response?.error ||
                    t("128")
                );
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <Layout>
            <SubLayout>
                <Header active={4} hide={true} />

                <button type="button" className={classes.back_button} onClick={() => navigate(-1)}>
                    <FaArrowLeft color='white' />
                </button>

                <Container style={{ gap: "16px" }}>
                    {loading ? (
                        <SmallLoader />
                    ) : data?.length > 0 ? (
                        <div className={classes.card}>
                            <div className={classes.cardHeader}>
                                <p className={classes.cardTitle}>{t("153")}</p>
                            </div>
                            <table className={classes.table}>
                                <thead>
                                    <tr>
                                        <th>{t("154")}</th>
                                        <th>{t("155")}</th>
                                        <th>{t("156")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.month}</td>
                                            <td>
                                                <span className={`${classes.rankPill}`}>
                                                    {item.rank}
                                                </span>
                                            </td>
                                            <td>{Number(item.total_points).toLocaleString()}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className={classes.empty}>{t("157")}</p>
                    )}
                </Container>
            </SubLayout>
        </Layout>
    );
};

export default WinningHistory;